import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface Book {
  id: number;
  url_image: string;
  url_book: string;
  title: string;
}

@Injectable({
  providedIn: 'root',
})
export class BookService {
  private apiUrl = 'https://9issati.net/mobile/9issati/perAge/1/1/6';

  constructor(private http: HttpClient) {}

  getBooks(): Observable<Book[]> {
    return this.http.get<Book[]>(this.apiUrl); 
    
  }
}
